import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import { AuthProvider } from "./AuthContext";
import ProtectedRoute from "./Components/ProtectedRoute";
import PublicLayout from "./Layouts/PublicLayout";
import AdminLayout from "./Layouts/AdminLayout";
import HomeContent from "./Pages/HomeContent/HomeContent";
import Bodyfriend from "./Pages/Bodyfriend/BodyfriendMain";
import Product from "./Pages/ProductPage/Product";
import AboutUs from "./Pages/AboutUs/AboutMain";
import FAQ from "./Pages/FAQ/FAQSection";
import ContactUs from "./Pages/ContactUs/ContactUsMain";
import TermsOfUse from "./Pages/Terms&Policy/TermsIndex";
import PrivacyPolicy from "./Pages/Terms&Policy/PolicyIndex";
import ReviewForm from "./Pages/ProductPage/ReviewForm";
import EventSection from "./Pages/Event/EventSection";
import EventDetails from "./Pages/Event/EventDetails";
import ProductTrial from "./Pages/ProductTrial/ProductTrial";
import StoreLocator from "./Pages/StoreLocator/StoreLocator";
import Login from "./Pages/Manage/Login/Login";
import ForgotPassword from "./Pages/Manage/Login/ForgotPassword";
import Appointment from "./Pages/Manage/Appointment/Appointment";
import Promotions from "./Pages/Promotions/Promotions";
import PromotionsDetail from "./Pages/Promotions/PromotionsDetail";

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppRoutes />
      </Router>
    </AuthProvider>
  );
}

function AppRoutes() {
  const location = useLocation();
  const isAdminRoute =
    location.pathname.startsWith("/admin") ||
    location.pathname === "/admin-login";

  return (
    <Routes>
      {/* Public routes wrapped with PublicLayout */}
      <Route
        path="/"
        element={
          <PublicLayout>
            <HomeContent />
          </PublicLayout>
        }
      />
      <Route
        path="/bodyfriend-products"
        element={
          <PublicLayout>
            <Bodyfriend />
          </PublicLayout>
        }
      />
      <Route
        path="/about-us"
        element={
          <PublicLayout>
            <AboutUs />
          </PublicLayout>
        }
      />
      <Route
        path="/FAQ"
        element={
          <PublicLayout>
            <FAQ />
          </PublicLayout>
        }
      />
      <Route
        path="/contact-us"
        element={
          <PublicLayout>
            <ContactUs />
          </PublicLayout>
        }
      />
      <Route
        path="/terms-of-use"
        element={
          <PublicLayout>
            <TermsOfUse />
          </PublicLayout>
        }
      />
      <Route
        path="/privacy-policy"
        element={
          <PublicLayout>
            <PrivacyPolicy />
          </PublicLayout>
        }
      />
      <Route
        path="/review"
        element={
          <PublicLayout>
            <ReviewForm />
          </PublicLayout>
        }
      />
      <Route
        path="/events"
        element={
          <PublicLayout>
            <EventSection />
          </PublicLayout>
        }
      />
      <Route
        path="/events/:id"
        element={
          <PublicLayout>
            <EventDetails />
          </PublicLayout>
        }
      />
      <Route
        path="/product-trial"
        element={
          <PublicLayout>
            <ProductTrial />
          </PublicLayout>
        }
      />
      <Route
        path="/store"
        element={
          <PublicLayout>
            <StoreLocator />
          </PublicLayout>
        }
      />
      {/* 促销路由 - 放在 /:slug 之前 */}
      <Route
        path="/promotions"
        element={
          <PublicLayout>
            <Promotions />
          </PublicLayout>
        }
      />
      <Route
        path="/promotions/:slug"
        element={
          <PublicLayout>
            <PromotionsDetail />
          </PublicLayout>
        }
      />


      {/* 通用产品路由 - 放在最后 */}
      <Route
        path="/:slug"
        element={
          <PublicLayout>
            <Product />
          </PublicLayout>
        }
      />

      {/* Admin routes wrapped with AdminLayout */}
      <Route
        path="/admin-login"
        element={
          <AdminLayout>
            <Login />
          </AdminLayout>
        }
      />
      <Route
        path="/forgot-password"
        element={
          <AdminLayout>
            <ForgotPassword />
          </AdminLayout>
        }
      />
      <Route
        path="/admin/appointment"
        element={
          <ProtectedRoute>
            <AdminLayout>
              <Appointment />
            </AdminLayout>
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

export default App;